(() => {
  const roots = document.querySelectorAll('[data-product-section]');
  roots.forEach(root => {
    const gallery = root.querySelector('[data-product-gallery]');
    const form = root.querySelector('[data-product-form]');
    if (!gallery || !form || gallery.dataset.ppGalleryFix === 'true') return;
    gallery.dataset.ppGalleryFix = 'true';

    const slides = [...gallery.querySelectorAll('[data-media-index]')];
    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    const variantsNode = root.querySelector('[data-variants]');
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) {}

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const indexForMediaId = mediaId => {
      if (!mediaId) return -1;
      return slides.findIndex(slide => String(slide.dataset.mediaId) === String(mediaId));
    };
    const mediaIdForVariant = variant => variant?.featured_media?.id || variant?.featured_image?.id || null;
    const currentVariant = () => {
      const id = form.querySelector('[data-variant-id]')?.value;
      return variants.find(v => String(v.id) === String(id));
    };
    const nearestIndex = () => {
      const g = gallery.getBoundingClientRect();
      return slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - g.left);
        const bestDistance = Math.abs(slides[best].getBoundingClientRect().left - g.left);
        return distance < bestDistance ? index : best;
      }, 0);
    };
    const setActive = index => {
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      const count = root.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      const prev = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
    };
    const goTo = (index, smooth = true) => {
      index = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
      const target = slides[index];
      if (!target) return;
      const galleryBox = gallery.getBoundingClientRect();
      const targetBox = target.getBoundingClientRect();
      const left = gallery.scrollLeft + targetBox.left - galleryBox.left;
      gallery.scrollTo({ left, behavior: smooth && !reducedMotion() ? 'smooth' : 'auto' });
      setActive(index);
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        goTo(index);
      });
    });

    root.querySelector('[data-gallery-prev]')?.addEventListener('click', event => {
      event.stopImmediatePropagation();
      goTo(nearestIndex() - 1);
    }, true);
    root.querySelector('[data-gallery-next]')?.addEventListener('click', event => {
      event.stopImmediatePropagation();
      goTo(nearestIndex() + 1);
    }, true);

    let scrollFrame = 0;
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => setActive(nearestIndex()));
    }, { passive: true });

    // Variant radios are updated by product-page.js first. On the next frame,
    // read the selected variant and move only the gallery viewport (never the page).
    root.querySelectorAll('.pp-option-group input').forEach(input => {
      input.addEventListener('change', () => requestAnimationFrame(() => {
        const variant = currentVariant();
        const index = indexForMediaId(mediaIdForVariant(variant));
        if (index >= 0) goTo(index);
      }));
    });

    // Start on the media attached to a deep-linked/selected variant.
    requestAnimationFrame(() => {
      const index = indexForMediaId(mediaIdForVariant(currentVariant()));
      if (index >= 0) goTo(index, false);
      else setActive(nearestIndex());
    });
  });
})();
